import { notification } from 'antd';
import axios from 'axios';
import Cookies from 'universal-cookie';
import DOMAINS, { CURRENT_DOMAIN } from './Domains';
import { PRIVATE_PDF_KEY, PDF_CRYTO_PADDING } from './constants/defaultVariables.consants';
import env from './env';
import Rijndael from 'rijndael-js';

export function getUserToken() {
  const cookies = new Cookies();
  return cookies.get('ReaderCookie')?.Token;
}

function getDomain(key = CURRENT_DOMAIN) {
  return DOMAINS[key] || 'http://lib.ctump.edu.vn/';
}

export function showMessage(title, message) {
  notification.open({
    message: title,
    description: message,
  });
}

export function getRequest(url, config) {
  return axios
    .get(`${window.getLinkHomepage()}api/${url}`, config)
    .then((res) => res.data);
}

export function postRequest(url, params, config) {
  return axios
    .post(`${window.getLinkHomepage()}api/${url}`, params, config)
    .then((res) => res.data);
}

export function downloadFromUrl(fileUrl, fileName) {
  const aElement = document.createElement('a');
  aElement.setAttribute('download', fileName);
  const href = fileUrl;
  aElement.href = fileUrl;
  aElement.setAttribute('target', '_blank');
  aElement.click();
  URL.revokeObjectURL(href);
}

export const removeVietmanmeseCode = (value) => {
  let str = value;
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  str = str.replace(/Đ/g, 'D');
  return str;
};

export const searchValue = (searchText, origin) =>
  removeVietmanmeseCode(origin.toLowerCase()).includes(
    removeVietmanmeseCode(searchText)
  );

export const descryptRijndaelCode = (password) => {
  const Buffer = require('buffer/').Buffer;
  const padding = PDF_CRYTO_PADDING;
  const rawPrivateKey = PRIVATE_PDF_KEY;
  
  const privateKey16 = rawPrivateKey.substring(0, 16);

  const cipher = new Rijndael(privateKey16, 'cbc');

  const passwordBytes = Buffer.from(password, 'base64');
  const decryptedArray = Buffer.from(cipher.decrypt(passwordBytes, 128, privateKey16));
 
  const filePassword = decryptedArray.toString();

  return filePassword.slice(0, filePassword.length - padding);
};

export default getDomain;
